export default __webpack_public_path__ + "817fc61534a173c36035164ce0305b56.svg";